var exports = {
  "m": "clearButton__zWB3bC",
};

module.exports = exports;
